import SparkMD5 from "spark-md5";

async function calculateMD5(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const md5Hash = SparkMD5.ArrayBuffer.hash(
        e.target?.result as ArrayBuffer,
      );
      resolve(md5Hash);
    };
    reader.onerror = (err) => reject(err);
    reader.readAsArrayBuffer(file);
  });
}

export default calculateMD5;
